import React, { useState, useMemo, useCallback, useContext } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { useQuery, useQueryClient } from "react-query";
import { EditOutlined, EyeOutlined} from "@ant-design/icons";
import TableContainerMin from "../../../../Components/Common/TableContainer";
import { Button, Modal, Spin } from "antd";
import HistoryContext from "../../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../../Styles/style.css";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // Importation de useTranslation
import vector1Icon from '../../../../assets/images/Vector1.png';
import { deleteRole, getRoles } from "../../../Administration/Roles/services/RoleApi";
import BreadCrumb from "../../../../Components/Common/BreadCrumb/BreadCrumb";
import AddEditRoleForm from "../../../Users/component/AddEditRole";
const Roles = (modal) => {
  const { t } = useTranslation();  // Hook pour récupérer les traductions
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  document.title = `Roles | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteTargetFullName, setDeleteTargetFullName] = useState("")
  const { isLoading, isError, error, data: roles } = useQuery("roles", getRoles);
   const [isModalOpenExport, setIsModalOpenExport] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = useCallback((role = null) => {
     setSelectedRole(role);  // Assure que vous avez le bon véhicule sélectionné
     setIsModalOpen(prev => !prev);  // Change l'état d'ouverture du modal
   }, []);
  const toggleModalExport = () => {
    setIsModalOpenExport(prev => !prev);
  };

  const toggleDetailModal = useCallback((role = null) => {
    setSelectedRole(role);
    setIsDetailModalOpen(prev => !prev);
  }, []);
  
  const toggleAddEditModal = useCallback((role = null) => {
    setSelectedRole(role);
    setIsAddEditModalOpen(prev => !prev);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
  }, [isDetailModalOpen]);

const handleEdit = (role) => {
    toggleAddEditModal(role);
  };
 
 
  const handleDetail = (roleId) => {
    const role = roles.find(r => r.id === roleId);
    if (role) {
      setSelectedRole(role); 
      toggleDetailModal(role); 
    } else {
      console.error("Rôle introuvable");
    }
  };
  
  const handleDelete = async (roleId) => {
    try {
      await deleteRole(roleId);
      queryClient.invalidateQueries("roles");
      toast.success("L'utilisateur a été supprimé avec succès 🎉");
    } catch (error) {
      console.error("Error deleting driver:", error);
      toast.error(`😔 Erreur lors de la suppression d'utilisateur : ${error?.message || error}`);
    } finally {
      setDeleteConfirmModal(false);
    }
  };
  

  const openDeleteConfirmModal = (roleId) => {
    const roleToDelete = roles.find(role => role.id === roleId);
    if (roleToDelete) {
      setDeleteTargetId(roleId);
      setDeleteTargetFullName(roleToDelete.name);
      setDeleteConfirmModal(true);
    }
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };
   const [isAllSelected, setIsAllSelected] = useState(false);
   const [selectedRows, setSelectedRows] = useState([]);
    const [isChecked, setIsChecked] = useState(false)
  const columns = useMemo(() => [
    {
      Header: () => <div style={{ textAlign: "start",color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'  }}>{t("roles.name")}</div>,
      accessor: "name",
      Cell: ({ row }) => (
        <div className="text-start">{row.original.name || t("drivers.noEmail")}</div>),
      filterable: false
    },
    {
      Header: () => <div style={{ textAlign: "center" ,color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px' }}>Date de création</div>,
      accessor: "createdAt",
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value ? new Date(value).toLocaleDateString('fr-FR') : "-"}
        </div>
      ),
      filterable: false,
    },
    {
      Header: () => <div style={{ textAlign: "center",color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px' }}>Date de modification</div>,
      accessor: "updatedAt",
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value ? new Date(value).toLocaleDateString('fr-FR') : "-"}
        </div>
      ),
      filterable: false,
    },
    {
          Header: () => <div style={{ textAlign: "end",color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'  }}>{t("vehicle.actions")}</div>,
          accessor: "action",
          headerStyle: { textAlign: "text-center" },
          Cell: ({ row }) => (
            <div className="actions-cell">        
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "50%",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                  cursor: "pointer"
                }}
                onClick={() => toggleModal(row.original)}  
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6" cy="12" r="2" fill="#004D47" />
                  <circle cx="12" cy="12" r="2" fill="#004D47" />
                  <circle cx="18" cy="12" r="2" fill="#004D47" />
                </svg>
              </div>
            </div>
          ),
          filterable: false,
        },
   
  ], [handleEdit, openDeleteConfirmModal,handleDetail]);
  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    bigButton: {
      display: "flex", 
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 10px",
      backgroundColor: '#F6F6F6',
      color: "white",
      border: "none",
      borderRadius: "40px", 
      cursor: "pointer",
      fontSize: "16px", 
      position: "relative",
    },
    tabContainer: {
      display: "flex",
      gap: "5px",
      flexDirection: "row",
      
    },
    tabButton: {
      padding: "5px 16px", 
      border: "none",
      borderRadius: "20px", 
      cursor: "pointer",
      fontSize: "14px", 
      transition: "background-color 0.3s",
      font:"Inter",
      fontWeight: "bold",
      backgroundColor: '#F6F6F6',
  
    },
  };
  const navigate = useNavigate();
  const HeaderTable = () => (
    <div className="gap-3">
    <div className="d-flex justify-content-between align-items-center w-100">
       
    <div className="d-flex gap-3">
      <strong style={{ fontSize: "24px" }}>
        {t("roles.listTitle")}
      </strong>
    </div>
    <div
      style={{
        display: "flex",
        alignItems: "center", 
        gap: "10px", 
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "30px",
          height: "30px",
          backgroundColor: "#f5f5f5",
          borderRadius: "50%",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
          cursor: "pointer", 
        }}
        onClick={toggleModalExport}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="12" r="2" fill="#151515" />
          <circle cx="12" cy="12" r="2" fill="#151515" />
          <circle cx="18" cy="12" r="2" fill="#151515" />
        </svg>
      </div>
      <button
       className="buttonAdd"
        onMouseOver={(e) => (e.target.style.backgroundColor = ' #151515')}
        onMouseOut={(e) => (e.target.style.backgroundColor = ' #151515')}
        onClick={() => toggleAddEditModal(null)}
      >
    {t("roles.addRoleButton")}
      </button>

    </div>
  </div>
  <div style={{ marginTop: "20px" }}></div> 
  </div>
 
  );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("roles.listTitle")} history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable/>
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={roles || []}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    SearchPlaceholder={t("drivers.searchPlaceholder")}
                      isRowVisible={isChecked}
                    HeaderTable={HeaderTable}
                  />
                  {isLoading && !isError && (
                    <div className="text-center">
                      {t("drivers.loading")} <Spin />
                    </div>
                  )}
                  {isError && (
                    <div className="text-center">
                      {t("drivers.error")}: {error?.message || error}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AddEditRoleForm
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedRole={selectedRole}
          />
          
          <Modal
            title={t("drivers.deleteConfirmationTitle")}
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
            footer={[
              <Button key="cancel" onClick={closeDeleteConfirmModal} className="bordered-btn-delete">
                {t("drivers.no")}
              </Button>,
              <Button key="delete" type="danger" onClick={() => handleDelete(deleteTargetId)} className="bordered-btn">
                {t("drivers.yes")}
              </Button>,
            ]}
            width={400}
            style={{ top: 200 }}
          >
            <p>{t("drivers.deleteConfirmationMessage")}{deleteTargetFullName} ?</p>
          </Modal>
         <Modal
        className={`modal-right ${modal ? 'open' : ''}`}  
          visible={isModalOpenExport}
          onCancel={toggleModalExport}
          footer={null}
          width={261}
          height={120}
          radiuis={9.6} 
          border={0.96}
        >
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    
    <a
  onClick={() => {
    console.log("Exportation CSV...");
    toggleModalExport();
  }}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    alignItems: "center" 
  }}
>
  <img src={vector1Icon} alt="Export en csv" style={{ marginRight: '8px' }} />
  <span>Exporter en CSV</span >
</a>

  </div>
</Modal>  
<Modal
  open={isModalOpen}
  onCancel={() => toggleModal()} 
  footer={null}
  width={190}
  height={10}
  radiuis={9.6} 
  border={0.96}
  
style={{top:'350px',right:'10px',position:'absolute'}}
 
>
<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <a 
   onClick={() => handleDetail(selectedRole.id)}
      style={{
         display: "flex",
    alignItems: "center",
       marginRight:'8px',
      fontFamily:"inter",
      fontWeight:'400px',
        width: "100%",
        marginBottom: "16px" 
      }}
    >
    <EyeOutlined style={{ color: ' #898989',width:'20px' }}  />
     <span style={{size:'14px',color:" #252525"}} >Voir détails</span>
    </a>
    <a
  onClick={() => handleEdit(selectedRole)}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    marginBottom: "16px" 
  }}
>
      <EditOutlined style={{ color: ' #898989' }} />       
  <span style={{marginLeft:'10px'}} >Editer </span >
</a>

  </div>
</Modal>
<Modal
  open={isDetailModalOpen} 
  onCancel={() => toggleDetailModal()} 
  footer={null}
  title={`Détails du rôle - ${selectedRole?.name || "Inconnu"}`}
>
  {selectedRole ? (
    <div>
      <p><strong>Nom :</strong> {selectedRole.name}</p>
      <p><strong>Date de création :</strong> {new Date(selectedRole.createdAt).toLocaleDateString('fr-FR')}</p>
      <p><strong>Date de modification :</strong> {new Date(selectedRole.updatedAt).toLocaleDateString('fr-FR')}</p>
      <p><strong>Description :</strong> {selectedRole.description}</p>
    </div>
  ) : (
    <p>Le rôle sélectionné est introuvable. Veuillez réessayer.</p>
  )}
</Modal>


        </Container>
      </div>
    </React.Fragment>
  );
};
export default Roles;
